import React from 'react'
import {Grid, Modal, Message, Button, Icon, Header, Placeholder, Table} from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import * as routerActions from '../../actions/RouterActions'
import {StoreEdit} from './storeedit.js'

export const StoreDetails = function (props) {
    const firestore = useFirestore();
    const lotteryId = props.match.params.lotteryId;
    const filter = (typeof props.match.params.filter !== 'undefined')?props.match.params.filter:null;
    const storeId = props.match.params.storeId;

    const dispatch = useDispatch()

    const store = useSelector(({ firestore: { data } }) => data['environments/dev/store-locator/' + lotteryId + '/stores'] && data['environments/dev/store-locator/' + lotteryId + '/stores'][storeId])
    function isValid(store){
        if(typeof store.geocode !== 'undefined' && store.geocode !== null)return true;
        return false;
    }

    function getError(store){
        if(typeof store.geocode !== 'undefined' && store.geocode !== null)return null;
        
        if(store.valid){
            return 'missing_geocode';
        }else{
            return store.error;
        }
    }

    return (
        <div>
          <Modal open={true} size="small">

            <Modal.Header>Store</Modal.Header>
            <Modal.Content scrolling>

                <Modal.Description>
                    {
                        (typeof store === 'undefined')?
                            <Placeholder>
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                            </Placeholder>
                        :
                        <div>
                            {
                                (isValid(store))?
                                    <Message color="teal"><Icon color='teal' circular name="checkmark" bordered inverted /> Dieser Eintrag ist gültig</Message>
                                :
                                    (getError(store) === 'missing_geocode')?
                                        <Message color="red">
                                        
                                            <Icon.Group size="big">
                                                <Icon name="google" circular size="tiny" inverted color="grey"/>
                                                <Icon corner='top right' name='question circle' color="red" />
                                            </Icon.Group> Dieser Eintrag ist ungültig: Für diese Adresse konnten keine Informationen über die Google Location API gefunden werden.
                                        </Message>
                                    :
                                        (getError(store) === 'missing_address')?
                                            <Message color="red">
                                                <Icon.Group size="big">
                                                    <Icon name="filter" circular size="tiny" inverted color="grey"/>
                                                    <Icon corner='top right' name='question circle' color="red" />
                                                </Icon.Group> Dieser Eintrag ist ungültig, da ein Formatfehler vorliegt: Für diese Eintrag konnte keine gültige Adresse aus den Rohdaten extrahiert werden.
                                            </Message>
                                        :
                                            (getError(store) === 'item_on_blacklist')?
                                                <Message>
                                                    <Icon name="ban" color="black" /> Dieser Eintrag wurde gesperrt.
                                                </Message>
                                            :
                                                <Message color="red">
                                                    <Icon name='question circle' color="bug" />
                                                        Dieser Eintrag ist ungültig. Fehlercode: {getError(store)}
                                                </Message>
                            }

                            {
                                (store.geocode)?
                                (
                                    <div>
                                        <Header>Google Location API Informationen</Header>

                                        <Header as='h4'>Formatierte Adresse:</Header>
                                        <span>
                                        {
                                            store.geocode.formatted_address
                                        }
                                        </span>

                                        <Header as='h4'>Place ID:</Header>
                                        <span>
                                        {
                                            store.geocode.place_id
                                        }
                                        </span>

                                        <Header as='h4'>Koordinaten:</Header>
                                        <span>
                                        {
                                            store.geocode.geometry.location.lat + ' , ' + store.geocode.geometry.location.lng
                                        }
                                        </span>
                                    </div>
                                )
                                :
                                    <div>
                                    {
                                        (getError(store) === 'missing_geocode')?
                                            <div style={{
                                                paddingBottom: '20px'
                                            }}>
                                                <Header>Aus RMF extrahierte Adresse</Header>
                                                <Header as='h4'>Straße:</Header>
                                                <span>
                                                {
                                                    store.street
                                                }
                                                </span>
                                                <Header as='h4'>Ort:</Header>
                                                <span>
                                                {
                                                    store.city
                                                }
                                                </span>
                                                <Header as='h4'>Land:</Header>
                                                <span>
                                                {
                                                    store.country
                                                }
                                                </span>
                                            </div>
                                        :null
                                    }
                                    {
                                        (getError(store) === 'missing_address' || getError(store) === 'missing_geocode' || getError(store) === 'item_on_blacklist')?
                                            <div>
                                                <Header>Rohdaten aus Retailer Masterfile</Header>
                                                <Table celled>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell>
                                                                Spalte
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                Wert
                                                            </Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                    {store.source.split('|').map((col, idx) => (
                                                        <Table.Row>
                                                            <Table.Cell>{idx + 1}</Table.Cell>
                                                            <Table.Cell>{col}</Table.Cell>
                                                        </Table.Row>
                                                    ))}
                                                    </Table.Body>
                                                </Table>
                                            </div>
                                        :
                                            null
                                    }
                                    </div>
                            }
                        </div>
                    }
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Grid columns={(typeof store === 'undefined')?1:3}>
                    {
                        (typeof store !== 'undefined')?
                            <Grid.Column textAlign="left">
                                <Button icon labelPosition='left' fluid onClick={() => dispatch(routerActions.push('storelocator/stores/' + lotteryId + (filter?('/' + filter):'')))}>
                                    <Icon name="edit" />
                                    {
                                        (store.geocode)?
                                            "Adresse ändern"
                                        :"Adresse eingeben"
                                    }
                                </Button>
                            </Grid.Column>
                        :null
                    }
                    {
                        (typeof store !== 'undefined')?
                            <Grid.Column textAlign="left">
                                <Button icon labelPosition='left' negative fluid onClick={() => dispatch(routerActions.push('storelocator/stores/' + lotteryId + (filter?('/' + filter):'')))}>
                                    <Icon name="ban" />
                                    {
                                        (getError(store) !== 'item_on_blacklist')?"Eintrag sperren":"Eintrag entsperren"
                                    }
                                </Button>
                            </Grid.Column>
                        :null
                    }
                    <Grid.Column>
                        <Button primary onClick={() => dispatch(routerActions.push('storelocator/stores/' + lotteryId + (filter?('/' + filter):'')))}>
                            Schließen
                        </Button>
                    </Grid.Column>
                </Grid>
            </Modal.Actions>
        </Modal>
                <StoreEdit />
        </div>
    )
}